import Vue from "vue";
import Vuex from "vuex";
import gateway from "@/services/gateway";
import errors from "@/services/errors";
//import axios from "axios";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    paymentLink: null,
    customer: null,
    cardDetails: null
  },
  mutations: {
    SET_PAYMENT_LINK(state, payload) {
      state.paymentLink = payload;
    },
    SET_CUSTOMER(state, payload) {
      state.customer = payload;
    },
    SET_CARD_DETAILS(state, payload) {
      state.cardDetails = payload;
    }
  },
  actions: {
    async load({ commit }, token) {
      try {
        //console.log("userStore: user data stored");
        const res = await Vue.prototype.$axios.get(
          `/public/payment-links/${token}`
        );
        if (res.status != 200) {
          throw new Error("No se pudo cargar el link de pagos.");
        }
        commit("SET_PAYMENT_LINK", res.data);
        return res.data;
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    async pay(
      { commit },
      { paymentFormPayload, customerFormPayload, linkToken }
    ) {
      try {
        const x = 10;
        const res = await Vue.prototype.$axios.post(
          `public/payment-links/pay/${linkToken}`,
          {
            firstName: customerFormPayload.firstName || null,
            lastName: customerFormPayload.lastName || null,
            email: customerFormPayload.email,
            phone: customerFormPayload.tel || null,
            DNI: customerFormPayload.DNI || null,
            linkToken,
            cardToken: paymentFormPayload.tempCardToken,
            paymentCourierId: paymentFormPayload.paymentCourierId,
            cardSecurityCode: paymentFormPayload.CVC,
            cardBin: paymentFormPayload.bin,
            lastFourDigits: paymentFormPayload.lastFourDigits,
            expirationDate: paymentFormPayload.expirationDate,
            cardName: paymentFormPayload.cardName,
            cardDNI: paymentFormPayload.cardDNI,
            installments: paymentFormPayload.installments
          }
        );
        if (res.status != 201) {
          const err = errors.handleHTTPError(res);
          throw err;
        }
        const z = 10;
        return res.data;
      } catch (err) {
        throw err;
      }
    }
  },
  getters: {
    paymentLink: state => {
      return state.paymentLink;
    },
    customer: state => {
      return state.customer;
    }
  }
};
